module.exports = __webpack_public_path__ + "static/media/ico-star-half-left.c767c5fd.svg";